import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmModal } from '@app/shared/modals';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { MessageTemplateService } from 'src/modules/features/setting/services';

@Component({
  selector: 'app-message-template-row',
  templateUrl: './message-row.component.html',
  styleUrls: ['./message-row.component.scss'],
})
export class MessageRowComponent implements OnInit {
  @Input() template: any;
  @Output() onDelete = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() enableSms = new EventEmitter();
  @Output() enableEmail = new EventEmitter();
  @Output() reloadPage = new EventEmitter();

  templateForm: FormGroup;

  constructor(
    private modalService: SuiModalService,
    private router: Router,
    private service: MessageTemplateService
  ) {}
  ngOnInit(): void {
    this.templateForm = new FormGroup({
      sms: new FormControl(this.template?.smsEnabled ?? false),
      email: new FormControl(this.template?.emailEnabled ?? false),
    });

    this.templateForm.get('sms').valueChanges.subscribe((e) => {
      if (e) {
        this.modalService
          .open(
            new ConfirmModal(
              'Activate SMS',
              'Are you sure you want to activate SMS on this message template?',
              ModalSize.Mini
            )
          )
          .onApprove((f) => {
            this.enableSms.emit({
              messageTemplateId: this.template.messageTemplateId,
              status: e,
            });
          })
          .onDeny((g) => {
            this.reloadPage.emit();
          });
      } else {
        this.modalService
          .open(
            new ConfirmModal(
              'De-activate SMS',
              'Are you sure you want to de-activate SMS on this message template?',
              ModalSize.Mini
            )
          )
          .onApprove((f) => {
            this.enableSms.emit({
              messageTemplateId: this.template.messageTemplateId,
              status: e,
            });
          })
          .onDeny((g) => {
            this.reloadPage.emit();
          });
      }
    });

    this.templateForm.get('email').valueChanges.subscribe((e) => {
      if (e) {
        this.modalService
          .open(
            new ConfirmModal(
              'Activate Email',
              'Are you sure you want to activate email on this message template?',
              ModalSize.Mini
            )
          )
          .onApprove((f) => {
            this.enableEmail.emit({
              messageTemplateId: this.template.messageTemplateId,
              status: e,
            });
          })
          .onDeny((g) => {});
      } else {
        this.modalService
          .open(
            new ConfirmModal(
              'De-activate Email',
              'Are you sure you want to de-activate email on this message template?',
              ModalSize.Mini
            )
          )
          .onApprove((f) => {
            this.enableEmail.emit({
              messageTemplateId: this.template.messageTemplateId,
              status: e,
            });
          })
          .onDeny((g) => {});
      }
    });
  }
}
